<div
    mat-dialog-content
    class="kh-loader-dialog__content"
>
    <mat-spinner [diameter]="80"></mat-spinner>
    <p class="body-medium">{{ data }}</p>
</div>
